import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './locales/de/common.json';
import en from './locales/en/common.json';
import tr from './locales/tr/common.json';
import ru from './locales/ru/common.json';
import hr from './locales/hr/common.json';
import it from './locales/it/common.json';

const resources = {
  de: { translation: de },
  en: { translation: en },
  tr: { translation: tr },
  ru: { translation: ru },
  hr: { translation: hr },
  it: { translation: it }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    supportedLngs: ['de', 'en', 'tr', 'ru', 'hr', 'it'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
